let collapseElement = $('[id^="collapse-"]');

collapseElement.on('show.bs.collapse', function () {
    let button = $(this).closest('.card').find("button[aria-controls=" + this.id + "]");
    button.find('i').removeClass('fa-chevron-down', 2000).addClass('fa-chevron-up', 2000);
})

collapseElement.on('hide.bs.collapse', function () {
    let button = $(this).closest('.card').find("button[aria-controls=" + this.id + "]");
    button.find('i').removeClass('fa-chevron-up', 2000).addClass('fa-chevron-down', 2000);
})
